<script lang="ts">
  import { page } from '$app/stores';
  import { cn } from '$lib/utils/misc';
  import { ForumType } from '$shared/lib';
  import Icon from './icon.svelte';
  import type { IconName } from './index';

  export let icon: IconName;
  export let name: string;
  export let divider = false;
  export let pointer = true;
  export let href: string | null = null;
  export let badge = 0;
  export let onClick = () => {};
  export let state: 'focus' | 'active' | 'inactive' = 'inactive';
  export let forumType: ForumType;

  $: hrefWithQueryParams = href ? href + $page.url.search : null;
</script>

{#if href}
  <a
    class="flex w-full cursor-pointer items-center justify-between gap-2 px-2 py-1.5"
    href={hrefWithQueryParams}
    class:active={state === 'active'}
  >
    <div
      class="text-gray-dark-11 hover:text-gray-dark-12 flex items-center gap-1 text-sm font-normal"
      class:text-gray-dark-12={state === 'focus' || state === 'active'}
    >
      <Icon
        {icon}
        class={cn(
          state === 'active' && forumType === ForumType.PUBLIC && 'text-mint-dark-11',
          state === 'active' && forumType === ForumType.ACCELERATOR && 'text-orange-dark-10',
          state === 'active' && forumType === ForumType.ADMIN && 'text-red-dark-10',
          'size-4',
        )}
      />
      <span>{name}</span>
    </div>
    {#if divider}
      <div class="mt-2 flex grow items-center">
        <div class="bg-gray-dark-3 h-px flex-1" />
        <div class="ml-2xs bg-gray-dark-6 h-1 w-1" />
      </div>
    {/if}
    {#if badge}
      <div
        class="bg-gray-dark-3 font-architekt text-gray-dark-12 rounded p-1 text-xs font-semibold"
      >
        {badge}
      </div>
    {/if}
  </a>
{:else}
  <button
    class="flex w-full cursor-pointer gap-2"
    on:click={onClick}
    class:pointer-events-none={!pointer}
  >
    <div
      class="text-gray-dark-11 hover:text-gray-dark-12 flex items-center gap-1 text-sm font-normal"
      class:text-gray-dark-12={state === 'focus' || state === 'active'}
    >
      <Icon
        {icon}
        class={cn(
          state === 'active' && forumType === ForumType.PUBLIC && 'text-mint-dark-11',
          state === 'active' && forumType === ForumType.ACCELERATOR && 'text-orange-dark-10',
          state === 'active' && forumType === ForumType.ADMIN && 'text-red-dark-10',
          'size-4',
        )}
      />
      <span>{name}</span>
    </div>
    {#if divider}
      <div class="mt-2 flex grow items-center">
        <div class="bg-gray-dark-3 h-px flex-1" />
        <div class="ml-2xs bg-gray-dark-6 h-1 w-1" />
      </div>
    {/if}
    {#if badge}
      <div
        class="bg-gray-dark-3 font-architekt text-gray-dark-12 rounded p-1 text-xs font-semibold"
      >
        {badge}
      </div>
    {/if}
  </button>
{/if}

<style lang="postcss">
  .active {
    @apply bg-gray-dark-2 text-gray-dark-12 rounded;
  }
</style>
